export default __webpack_public_path__ + "static/media/s1.1209d766.jpg";